import React from 'react';

function RipleyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 30 40"
      version="1.1"
      viewBox="0 0 30 40"
      xmlSpace="preserve"
      height="40px"
      width="50px"
    >
      <g transform="translate(-318.705 -225.771)">
        <path
          d="M347.93 256.68c0-.21-.26-.27-.26-.27-2.63-.67-4.99-2.12-6.78-4.16-2.5-2.69-4.66-5.68-6.43-8.91-.29-.66.12-.74.12-.74v-.01a9.3 9.3 0 005.83-8.3c0-6.34-6-8.22-11.41-8.22-2.04 0-2.72.17-4.85.17-2.48 0-3.96-.17-4.35-.17a.58.58 0 00-.55.63v.01c0 1.53 3.49-1.07 3.49 4.05v20.4c0 4.71-3.32 3.4-3.32 4.54 0 .39.43.52.68.52 1.24 0 2.64-.17 4.63-.17 2.52 0 3.17.17 4.61.17 1.06 0 1.23-.2 1.23-.52 0-1.44-4.47.77-4.47-5.35v-21.51c0-1.28.93-1.28 2.29-1.28 4.91 0 8.78 2.73 8.86 7.87.09 3.67-2.8 6.72-6.47 6.81h-.43c-.52.02-1.03-.01-1.54-.09-.21 0-.42.09-.42.38 0 .4.32.6.69.7 1.15.34 2.12 1.11 2.72 2.15 2.9 4.74 6.17 11.88 13.62 11.88 2.78.01 2.51-.33 2.51-.58z"
          style={{ fill: '#FFFFFF' }}
        />
        <g transform="translate(318.705 258.364)">
          <path
            d="M1.47 5.24c.25 0 .49.09.66.27.36.36.36.95 0 1.32-.36.36-.96.36-1.32 0a.975.975 0 01-.27-.66c0-.25.09-.48.27-.66.18-.18.41-.27.66-.27z"
            style={{ fill: '#FFFFFF' }}
          />
          <path
            d="M10.32 1.78l-1.35.74c-.4-.48-1-.74-1.62-.71-.55-.02-1.08.17-1.48.55-.38.36-.58.86-.56 1.39-.02.5.18.99.54 1.35.38.36.9.55 1.42.52.65.04 1.28-.24 1.7-.74l1.28.88a3.95 3.95 0 01-5.56.37c-.02-.01-.03-.03-.05-.04A3.353 3.353 0 015.45.76C6.04.45 6.68.29 7.34.3c.6-.01 1.19.12 1.73.38.5.26.93.63 1.25 1.1z"
            style={{ fill: '#FFFFFF' }}
          />
          <path
            d="M14.82.3c.6 0 1.2.16 1.72.46 1.06.6 1.71 1.72 1.71 2.93 0 .6-.15 1.19-.45 1.71-.29.52-.72.95-1.24 1.24-.53.3-1.12.46-1.73.45-.89.01-1.75-.34-2.37-.99a3.416 3.416 0 01.04-4.84c.03-.03.06-.06.09-.08.59-.57 1.39-.88 2.23-.88zm.02 1.53c-.48-.01-.93.18-1.26.53-.34.36-.52.85-.5 1.35-.02.5.16 1 .5 1.37.33.35.78.54 1.26.52.48.01.94-.18 1.27-.53.67-.78.67-1.93.01-2.71-.33-.36-.8-.55-1.28-.53z"
            style={{ fill: '#FFFFFF' }}
          />
          <path
            d="M19.55.47h1.62v.74c.26-.29.57-.52.92-.68.35-.15.73-.23 1.11-.23.39 0 .76.1 1.09.3.34.21.61.51.79.87.24-.36.57-.66.95-.87.38-.2.8-.3 1.23-.3.43-.01.85.1 1.21.32.33.19.59.49.75.84.18.54.26 1.11.23 1.68v3.79h-1.63V3.65c.05-.51-.05-1.03-.27-1.49a.948.948 0 00-.82-.39c-.27 0-.53.08-.75.24-.23.17-.4.39-.49.66a4.1 4.1 0 00-.16 1.35v2.92H23.7V3.8c.02-.42-.03-.85-.13-1.26-.06-.23-.2-.43-.38-.58a.99.99 0 00-.62-.19c-.26 0-.52.08-.74.24-.23.17-.4.41-.49.67-.13.44-.19.9-.16 1.37v2.88h-1.62V.47z"
            style={{ fill: '#FFFFFF' }}
          />
        </g>
      </g>
    </svg>
  );
}

export default RipleyIcon;
